import { Lock } from 'lucide-react';
import type { Permission } from '@mustauto/types/permissions';
import { holdersText, usePermissionHolders } from '@/hooks/useCan';

/**
 * No caminho natural de quem não pode, a ação fica desabilitada e a tela diz
 * quem pode (decisão 5 da prévia): "Quem muda os itens aqui é Ana ou Roberto."
 * Esconder pareceria defeito — a mesma classe de chamado da Classe 1 do suporte.
 */
export function WhoCanHint({ permission, action }: { permission: Permission; action: string }) {
  const names = usePermissionHolders(permission);
  return (
    <p className="flex items-center gap-1.5 text-xs text-muted-foreground">
      <Lock size={12} aria-hidden className="shrink-0" />
      Quem {action} aqui é {holdersText(names)}.
    </p>
  );
}
